<div class="breadcrumb-widget" data-automation-id="breadcrumbs">
    <div *ngFor="let breadcrumb of breadcrumbs; index as i" class="breadcrumb-item">
        <button type="button" class="btn btn-link" [disabled]="(i == breadcrumbs.length - 1) || breadcrumb.name == 'Searches'" (click)="navigate(breadcrumb)"
            [attr.data-automation-id]="'breadcrumb-' + i" [attr.title]="getTitle(breadcrumb)">{{breadcrumb.name}}</button>
        <div class="breadcrumb-arrow"><i class="fa fa-angle-right" [hidden]='i == breadcrumbs.length - 1'></i></div>
    </div>
</div>
